import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import getBodyForAuthenticationCall from 'utils/helpers/getBodyForAuthenticationCall';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { authenticate } from 'services/employee';

const getData = async ({ body }) => {
  try {
    const res = await authenticate(body);
    return res;
  } catch (err) {
    console.error('Error authenticating the user : ', err);
    throw err;
  }
};

export const useAuthenticate = () => {
  const history = useHistory();
  const body = getBodyForAuthenticationCall({
    path: history.location.pathname,
    locationSearch: history.location.search,
  });
  return useQuery([REACT_QUERY_KEYS.loggedInUser], () => getData({ body }), {
    onError: (error) => error,
    refetchOnWindowFocus: false, // <- temp, this should be turned back to true. Feed is causing error right now if set to true
  });
};

export const useAuthenticatedUser = () => {
  const userData = useSelector((state) => state.loggedInEmployee);

  // const userData = queryClient.getQueryData([REACT_QUERY_KEYS.loggedInUser]);
  return { user: userData?.data };
};

// commenting out actual react query hook.
// refer to app.js commented out useeffect comment

// export const useAuthenticatedUser = () => {
//   const queryClient = useQueryClient();
//   //   const isFetchingUserData = useIsFetching({
//   //     queryKey: [REACT_QUERY_KEYS.loggedInUser],
//   //     predicate: query => query.state.status === 'loading'
//   //   });
//   const userData = queryClient.getQueryData([REACT_QUERY_KEYS.loggedInUser]);
//   return { user: userData?.employee };
// };
